import { CancelOrderResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class OmsOrderTransactions<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags oms Order transactions
	 * @name OmsCancelOrderDetail
	 * @summary OMS order Options.
	 * @request GET:/store/{storeId}/oms/cancel_order/{orderId}/{zipCode}/{houseNumber}
	 * @secure
	 * @response `200` `CancelOrderResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	omsCancelOrderDetail = (
		storeId: string,
		orderId: string,
		zipCode?: string,
		houseNumber?: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['omsCancelOrderDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/oms/cancel_order/${orderId}/${zipCode}/${houseNumber}`,
				params: _params,
				query: query,
				methodName: 'omsCancelOrderDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<CancelOrderResponse, void>({
			path: `/store/${storeId}/oms/cancel_order/${orderId}/${zipCode}/${houseNumber}`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags oms Order transactions
	 * @name OmsProcessOrderDetail
	 * @summary OMS order Options.
	 * @request GET:/store/{storeId}/oms/process_order/{orderId}/{zipCode}/{houseNumber}
	 * @secure
	 * @response `200` `CancelOrderResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	omsProcessOrderDetail = (
		storeId: string,
		orderId: string,
		zipCode?: string,
		houseNumber?: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['omsProcessOrderDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/oms/process_order/${orderId}/${zipCode}/${houseNumber}`,
				params: _params,
				query: query,
				methodName: 'omsProcessOrderDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<CancelOrderResponse, void>({
			path: `/store/${storeId}/oms/process_order/${orderId}/${zipCode}/${houseNumber}`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
